import { SLMap } from './sl-map';
import { LayerRenderResult } from '../types/layerrenderresult';
import { dataURLToBlob } from 'blob-util';
import { SLLayer } from './sl-layer';
// @ts-ignore
import { LngLat, Map, LngLatBounds, ImageSource, LngLatLike } from '!mapbox-gl';
import { ViewContext } from '../types/view-context';
import { ILayerOverlay } from '../types/@types/sl-v-types';
import { ISLMap } from '../types/@types/sl-map';


export class LayerOverlay implements ILayerOverlay {
  id: string;
  renderId: string;
  source: mapboxgl.ImageSource;
  ui: mapboxgl.Layer;
  map: ISLMap;
  layer: mapboxgl.Layer;
  slLayer: SLLayer;

  layerURL: string = null;
  bounds: LngLatBounds = null;


  constructor(map: ISLMap, layer: SLLayer) {
    if (!isNaN(parseInt(layer.identifier.substring(0, 1)))) {
      this.id = 'L' + layer.identifier;
    } else {
      this.id = layer.identifier;
    }
    this.slLayer = layer;

    this.map = map;
    this.SetupLayer();


  }
  get isProjectLayer(): boolean {
    return this.slLayer.isPLayer;
  }
  HandleRenderResult(result: LayerRenderResult) {
    if (result === undefined) {
      return;
    }
    const mapUI = this.map.ui;
    const bbox = this.CorrectBBox(result.image.bbox);
    const minX = bbox[0];
    const minY = bbox[1];
    const maxX = bbox[2];
    const maxY = bbox[3];

    const boundCoords: Array<LngLatLike> = [];
    boundCoords.push([minX, maxY]);
    boundCoords.push([maxX, maxY]);
    boundCoords.push([maxX, minY]);
    boundCoords.push([minX, minY]);
    boundCoords.push([minX, maxY]);

    const blobURL: string = URL.createObjectURL(dataURLToBlob(result.image.content));
    (this.source as any).updateImage({ url: blobURL, coordinates: boundCoords });
    this.UpdateVisibility();
    this.UpdateOpacity();
    /**  this.rendered.emit({ id: this.identifier, isProjectLayer: this.isProjectLayer, status: 'ok' }); */
    // (mapUI as any).triggerRepaint();

  }

  Clear() {
    if (this.source === undefined) return;
    if(!this.map.component) return;
    let empty = this.map.component.layerAPI.empty;
    empty =  empty.endsWith('===') ? empty.replace('===','==') : empty.replace('==','===');
    (this.source as any).updateImage(
      {
        url: (!!this.map.component) ? this.map.component.layerAPI.empty : '',
        coordinates:this.source.coordinates
      }
    );

  }

  SetupLayer() {
    const mapUI: Map = this.map.ui as Map;
    const viewContext: ViewContext = this.map.currentViewState;

    const bounds: LngLatBounds = viewContext.bounds;
    const layerURL = (!!this.map.component) ? this.map.component.layerAPI.empty : '';

    const layerSource = {
      type: 'image',
      url: layerURL,
      coordinates: [
        bounds.getNorthWest().toArray(),
        bounds.getNorthEast().toArray(),
        bounds.getSouthEast().toArray(),
        bounds.getSouthWest().toArray()
      ]
    };


    this.map.ui.addSource(this.id + '-source', layerSource as mapboxgl.AnySourceData);
    this.source = this.map.ui.getSource(this.id + '-source') as ImageSource;
    const info: any = {
      id: this.id,
      type: 'raster',
      source: this.id + '-source',
      paint: { 'raster-opacity': this.isProjectLayer ? this.slLayer.opacity : 1, 'raster-fade-duration': 0, },
      layout: {
        visibility: (this.slLayer.layerOn && this.slLayer.parentVis) ? 'visible' : 'none'
      }
    };
    if (info.paint['raster-opacity'] === undefined) {
      info.paint['raster-opacity'] = 0;
    }
    mapUI.addLayer(info);
    this.layer = mapUI.getLayer(this.id);
  }
  Remove() {
    this.map.ui.removeLayer(this.layer.id);
    this.map.ui.removeSource(this.id + '-source');
    this.slLayer = undefined;
    this.map = undefined;

  }
  UpdateOpacity() {
    const layerOpacity = this.isProjectLayer ? this.slLayer.opacity * this.slLayer.parentOpacity : 1;
    this.map.ui.setPaintProperty(this.id, 'raster-opacity', layerOpacity);

  }
  UpdateVisibility() {
    if (this.slLayer.isPLayer) {
      let layerOn = this.slLayer.layerOn;
      if (this.slLayer.hasOwnProperty('manualVis')) {
        layerOn = layerOn && (this.slLayer as any).manualVis;
      }
      this.map.ui.setLayoutProperty(this.id, 'visibility', (layerOn && this.slLayer.parentVis) ? 'visible' : 'none');
    } else {
      this.map.ui.setLayoutProperty(this.id, 'visibility', this.slLayer.enabled ? 'visible' : 'none');
    }
  }
  CorrectBBox(bbox: [number, number, number, number]): [number, number, number, number] {
    const minPoint = new LngLat(bbox[0], bbox[1]).wrap();
    const maxPoint = new LngLat(bbox[2], bbox[3]).wrap();
    return [minPoint.lng, minPoint.lat, maxPoint.lng, maxPoint.lat];

  }



}

